import React, { useState, useEffect } from "react";
import './formEvaluationAnswerGroup.css';

import { Input, Radio, Checkbox, Slider, Typography, Space, Segmented } from "antd";
const { Text, Paragraph } = Typography;
const { TextArea } = Input;

const FormEvaluationAnswerGroupEv = ({
    evaluationAnswerGroup,
    source,
    question,
    evlCommentsOption,
    onChange,
    handleObservationChange,
    currentObservation
}) => {
    const [eagTitle, setEagTitle] = useState("");
    const [eagDescription, setEagDescription] = useState("");
    const [eagType, setEagType] = useState(null);
    const [eagMinValue, setEagMinValue] = useState(0);
    const [eagMaxValue, setEagMaxValue] = useState(5);
    const [eagTarget, setEagTarget] = useState("");
    const [eagOptions, setEagOptions] = useState([]);

    useEffect(() => {
        if (evaluationAnswerGroup) {
            setEagTitle(evaluationAnswerGroup.eag_title ?? "");
            setEagDescription(evaluationAnswerGroup.eag_description ?? "");
            setEagType(evaluationAnswerGroup.eag_type ?? null);
            setEagMinValue(
                evaluationAnswerGroup.eag_min_value !== undefined && evaluationAnswerGroup.eag_min_value !== null
                    ? evaluationAnswerGroup.eag_min_value
                    : 0
            );
            setEagMaxValue(
                evaluationAnswerGroup.eag_max_value !== undefined && evaluationAnswerGroup.eag_max_value !== null
                    ? evaluationAnswerGroup.eag_max_value
                    : 5
            );
            setEagTarget(evaluationAnswerGroup.eag_target ?? "");
            setEagOptions(evaluationAnswerGroup.eag_options ?? []);
        }
    }, [evaluationAnswerGroup]);
    

    const handleRadioChange = (e) => {
        const selected = eagOptions.find(opt => opt.eao_value === e.target.value);
        if (onChange && selected) {
            onChange({ value: selected.eao_value, text: selected.eao_text });
        }
    };

    const handleCheckboxChange = (checkedValues) => {
        const selected = eagOptions
            .filter(opt => checkedValues.includes(opt.eao_value))
            .map(opt => ({ value: opt.eao_value, text: opt.eao_text }));
        if (onChange) {
            onChange({ value: null, text: selected }); // se envía array de objetos
        }
    };

    const handleSliderChange = (value) => {
        if (onChange) {
            onChange({ value: value, text: null });
        }
    };

    const handleTextAreaChange = (e) => {
        if (onChange) {
            onChange({ value: null, text: e.target.value });
        }
    };

    const renderOptions = () => {
        const { ean_answer, ean_answer_text } = question;

        if (eagType === 1) {
            // Tipo RADIO
            return (
                <Radio.Group
                    style={{ width: "100%", display: 'flex', flexDirection: 'column', gap: 8 }}
                    onChange={handleRadioChange}
                    value={ean_answer ?? null}
                >
                    {eagOptions.map((option, idx) => (
                        <Radio key={idx} value={option.eao_value} style={{ fontSize: '16px' }}>
                            {option.eao_option}. {option.eao_text}
                        </Radio>
                    ))}
                </Radio.Group>
            );
        }

        if (eagType === 2) {
            // Tipo CHECKBOX
            const selectedValues = Array.isArray(ean_answer_text)
                ? ean_answer_text.map(item => item.value)
                : [];

            return (
                <Checkbox.Group
                    style={{ width: "100%" }}
                    onChange={handleCheckboxChange}
                    value={selectedValues}
                >
                    {eagOptions.map((option, idx) => (
                        <Checkbox key={idx} value={option.eao_value} style={{ fontSize: '16px' }}>
                            {option.eao_option}. {option.eao_text}
                        </Checkbox>
                    ))}
                </Checkbox.Group>
            );
        }

        if (eagType === 3) {
            // Tipo TEXTAREA
            return (
                <TextArea
                    style={{ fontSize: '16px' }}
                    rows={4}
                    onChange={handleTextAreaChange}
                    placeholder="Escribe tu respuesta..."
                    value={ean_answer_text ?? ""}
                />
            );
        }

        if (eagType === 4) {
            const numericOptions = [];
            for (let i = eagMinValue; i <= eagMaxValue; i++) {
                numericOptions.push(i);
            }

            return (
                <Segmented
                    block
                    options={numericOptions}
                    onChange={handleSliderChange}
                    value={ean_answer ?? null}
                    className="custom-segmented"
                />
            );
        }

        return null;
    };

    const formatWithLineBreaks = (text) => {
        if (!text) return null;
        return text.split('\n').map((line, index) => (
            <React.Fragment key={index}>
                {line}
                <br />
            </React.Fragment>
        ));
    };

    return (
        <Space direction="vertical" size="middle" style={{ width: "100%", margin: "0 auto" }}>
            {/* <div style={{ display: "flex", alignItems: "center", gap: 6 }}>
                <Text strong type="secondary">{eagTitle}</Text>
            </div> */}
            <Paragraph style={{ fontSize: '16px' }}>{formatWithLineBreaks(eagDescription)}</Paragraph>
            <Paragraph style={{ fontWeight: 500, textAlign: "justify", fontSize: '16px' }} type="secondary">{formatWithLineBreaks(question.ean_question)}</Paragraph>
            {renderOptions()}
            {
                source !== "evaluation" && (evlCommentsOption == 1 || evlCommentsOption == "1") && <div style={{ marginTop: 20 }}>
                    <Paragraph style={{ fontWeight: 500, fontSize: '16px' }} type="secondary">Observaciones</Paragraph>
                    <TextArea
                        rows={4}
                        placeholder="Utiliza este espacio para consignar tus observaciones"
                        value={currentObservation}
                        onChange={(e) => handleObservationChange(e.target.value)}
                        style={{ marginTop: 10, fontSize: '16px' }}
                    />
                </div>
            }
        </Space>
    );
};

export default FormEvaluationAnswerGroupEv;
